<template>
  <div
    :style="state.styleObject"
    class="koc-event-replay-sessions-item"
  >
    <div class="koc-event-replay-sessions-item-content">
      <div
        class="koc-event-replay-sessions-item-info"
      >
        <div
          :style="state.thumbnailStyleObject"
          class="koc-event-replay-sessions-item-thumbnail-container"
        >
          <div
            v-if="!state.isPlaceholder"
            class="koc-sponsor-card-play-arrow-circle"
          >
            <font-awesome-icon
              :icon="['fa', 'play']"
              class="koc-sponsor-card-play-arrow"
              @click="playVideo"
            />
          </div>
        </div>
        <div class="koc-event-session-text-column">
          <div
            class="koc-event-replay-sessions-item-title-row"
            @click="toggle"
          >
            <div
              class="koc-event-replay-sessions-item-title"
            >
              {{ session.name }}
            </div>
            <span
              v-if="state.hasDescription"
              class="koc-event-replay-sessions-item-caret-container"
            >
              <font-awesome-icon
                :class="{ 'open' : state.open }"
                :icon="['fa', 'chevron-down']"
                class="koc-event-replay-sessions-item-caret-icon"
              />
            </span>
          </div>
          <div
            v-if="state.instructorText"
            class="koc-event-replay-sessions-item-instructor"
          >
            with {{ state.instructorText }}
          </div>
          <div
            class="koc-event-replay-sessions-item-action"
          >
            <span
              v-if="state.isPlaceholder"
              class="koc-event-replay-sessions-item-coming-soon"
            >
              Session Replay Coming Soon
            </span>
            <a
              v-else
              class="koc-event-replay-sessions-item-action-link"
              @click="playVideo()"
            >Watch Video</a>
          </div>
        </div>
      </div>
      <div
        v-if="state.hasDescription"
        :class="{ 'koc-hidden' : !state.open }"
        class="koc-event-replay-sessions-item-description-panel"
      >
        <p v-html="session.description" />
      </div>
    </div>
  </div>
</template>

<script src="./event-replay-sessions-item.js"></script>
<style lang="scss" scoped src="./event-replay-sessions-item.scss"></style>
